// src/components/common/EntityProofreadingStatusChip.tsx
import React from "react";
import { Chip } from "@mui/material";
import { SystemEntityProofreadingStatus } from "../../../../shared/enums/shared-enums";
import { entityStatusConfigs } from "./utils";

export const EntityProofreadingStatusChip: React.FC<{
  status?: SystemEntityProofreadingStatus;
  small?: boolean;
}> = ({
  status = SystemEntityProofreadingStatus.NOT_PROOFREAD,
  small = false,
}) => {
  const cfg =
    entityStatusConfigs[status] ||
    entityStatusConfigs[SystemEntityProofreadingStatus.NOT_PROOFREAD];

  return (
    <Chip
      icon={cfg.icon}
      label={cfg.label}
      size={small ? "small" : "medium"}
      color={cfg.color}
      variant="filled"
    />
  );
};
